import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/survey',
  },
  {
    path: '/survey',
    name: 'survey',
    component: () =>
      import(/* webpackChunkName: "survey" */ '../layout/index.vue'),
    children: [
      // {
      //   path: '',
      //   name: 'home',
      //   meta: {
      //     needLogin: true,
      //     title: '首页',
      //   },
      //   component: () =>
      //     import(/* webpackChunkName: "survey" */ '../pages/home/index.vue'),
      // },
      {
        path: '',
        // path: 'surveyList',
        name: 'surveyList',
        meta: {
          needLogin: true,
          title: '问卷列表',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/list/index.vue'),
      },
      {
        path: 'planList',
        name: 'planList',
        meta: {
          needLogin: true,
          title: '计划列表',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/plan/index.vue'),
      },
      {
        path: 'bank',
        name: 'bank',
        meta: {
          needLogin: true,
          title: '题库管理',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/bank/index.vue'),
      },
      {
        path: 'user',
        name: 'user',
        meta: {
          needLogin: true,
          title: '用户管理',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/user/index.vue'),
      },
      {
        path: 'registerUser',
        name: 'registerUser',
        meta: {
          needLogin: true,
          title: '注册用户',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/registerUser/index.vue'),
      },
      {
        path: 'target/yyt',
        name: 'yyt',
        meta: {
          needLogin: true,
          title: '营业厅管理',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/target/yyt/index.vue'),
      },
      {
        path: 'target/qx',
        name: 'qx',
        meta: {
          needLogin: true,
          title: '抢修区域管理',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/target/qxArea/index.vue'),
      },
      {
        path: 'target/order',
        name: 'order',
        meta: {
          needLogin: true,
          title: '工单管理',
        },
        component: () =>
          import(/* webpackChunkName: "survey" */ '../pages/target/order/index.vue'),
      },
    ],
  },
  {
    path: '/survey/:id/edit',
    name: '',
    meta: {
      needLogin: true,
    },
    // redirect: '/question',
    component: () =>
      import(/* webpackChunkName: "editPage" */ '../pages/edit/index.vue'),
    children: [
      {
        path: '',
        name: 'QuestionEditIndex',

        meta: {
          needLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "QuestionEditIndex" */ '../pages/edit/pages/edit.vue'
          ),
      },
      {
        path: 'setting',
        name: 'QuestionEditSetting',
        meta: {
          needLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "QuestionEditSetting" */ '../pages/edit/pages/setting.vue'
          ),
      },
      {
        path: 'skin',
        name: '',
        meta: {
          needLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "skin" */ '../pages/edit/pages/skin/index.vue'
          ),
        children: [
          {
            path: '',
            name: 'QuestionSkinSetting',
            meta: {
              needLogin: true,
            },
            component: () => import('../pages/edit/pages/skin/content.vue'),
          },
          {
            path: 'result',
            name: 'QuestionEditResultConfig',
            meta: {
              needLogin: true,
            },
            component: () => import('../pages/edit/pages/skin/result.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/survey/:id/analysis',
    name: 'analysisPage',
    meta: {
      needLogin: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "analysisPage" */ '../pages/analysis/index.vue'
      ),
  },
  {
    path: '/survey/:id/publishResult',
    name: 'publishResultPage',
    meta: {
      needLogin: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "publishResultPage" */ '../pages/publishResult/index.vue'
      ),
  },
  {
    path: '/create',
    name: 'create',
    meta: {
      needLogin: true,
      title: '创建问卷',
    },
    component: () =>
      import(/* webpackChunkName: "create" */ '../pages/create/index.vue'),
  },
  {
    path: '/login',
    name: 'login',
    title: '登陆',
    component: () =>
      import(/* webpackChunkName: "login" */ '../pages/login/index.vue'),
  },
  {
    path: '/plan/:id/distribution',
    name: 'plandistributionPage',
    meta: {
      needLogin: true,
    },
    // redirect: '/question',
    component: () => import('../pages/planEdit/distribution.vue'),
  },
  {
    path: '/plan/:id/analysis',
    name: 'plananalysisPage',
    meta: {
      needLogin: true,
    },
    // redirect: '/question',
    component: () => import('../pages/planEdit/plananalysis.vue'),
  },
  {
    path: '/plan/:id/taskArchivist',
    name: 'planTaskArchivist',
    meta: {
      needLogin: true,
    },
    component: () => import('../pages/planEdit/taskArchivist.vue'),
  },
  {
    path: '/plan/:id/followAttachments',
    name: 'followAttachments',
    meta: {
      needLogin: true,
    },
    component: () => import('../pages/planEdit/followAttachments.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/management',
  routes,
});

router.beforeEach((to, from, next) => {
  const store = router.app.$options.store;
  if (!store?.state?.user?.initialized) {
    store.dispatch('user/init');
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.needLogin) {
    if (store?.state?.user?.hasLogined) {
      next();
    } else {
      next({
        name: 'login',
        query: {
          redirect: encodeURIComponent(to.path),
        },
      });
    }
  } else {
    next();
  }
});

export default router;
